import { toast } from "sonner";
import { CheckCircle2, Clock, Download } from "lucide-react";
import { eur } from "@/lib/format";
import { fechaCorta } from "@/components/contratos/constants";
import { METODOS } from "./portalApi";

const Resumen = ({ titulo, valor, cls, testid }) => (
  <div className="rounded-2xl bg-white border border-slate-200 px-4 py-3" data-testid={testid}>
    <p className="text-xs text-slate-500">{titulo}</p><p className={`text-lg sm:text-xl font-extrabold ${cls}`}>{eur(valor)}</p>
  </div>
);

export const PagosPortal = ({ pagos, api }) => {
  const pdf = (f) => api.descargar(`/facturas/${f.id}/pdf`, `${f.numero}.pdf`).catch(() => toast.error("No se pudo descargar la factura"));
  const cobros = pagos.facturas.flatMap((f) => f.cobros.map((c) => ({ ...c, numero: f.numero }))).sort((a, b) => (b.fecha || "").localeCompare(a.fecha || ""));
  const pendientes = pagos.facturas.filter((f) => Number(f.saldo) > 0.004);
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-2 sm:gap-3">
        <Resumen titulo="Total facturado" valor={pagos.total} cls="text-[#1B2B4B]" testid="pagos-total" />
        <Resumen titulo="Pagado" valor={pagos.pagado} cls="text-emerald-600" testid="pagos-pagado" />
        <Resumen titulo="Pendiente" valor={pagos.pendiente} cls={pagos.pendiente > 0 ? "text-amber-600" : "text-slate-400"} testid="pagos-pendiente" />
      </div>
      <div className="grid md:grid-cols-2 gap-3">
        <div className="rounded-2xl bg-white border border-slate-200 p-4" data-testid="pagos-pendientes">
          <p className="flex items-center gap-1.5 text-sm font-bold text-[#1B2B4B] mb-2"><Clock className="w-4 h-4 text-amber-500" /> Pagos pendientes</p>
          {pendientes.length === 0 ? <p className="text-xs text-slate-400">No tienes pagos pendientes.</p> : pendientes.map((f) => (
            <div key={f.id} className="flex items-center gap-2 py-2 border-b last:border-0 border-slate-100 text-sm" data-testid={`pago-pendiente-${f.id}`}>
              <div className="flex-1 min-w-0"><p className="font-semibold">{f.numero}</p><p className="text-xs text-slate-500">Vence el {fechaCorta(f.fecha_vencimiento)}{f.estado === "vencida" ? " · vencida" : ""}</p></div>
              <span className="font-bold text-amber-700 whitespace-nowrap">{eur(f.saldo)}</span>
              <button onClick={() => pdf(f)} className="p-1.5 rounded hover:bg-slate-100" aria-label="Descargar factura" data-testid={`factura-pdf-${f.id}`}><Download className="w-4 h-4 text-slate-500" /></button>
            </div>
          ))}
        </div>
        <div className="rounded-2xl bg-white border border-slate-200 p-4" data-testid="pagos-realizados">
          <p className="flex items-center gap-1.5 text-sm font-bold text-[#1B2B4B] mb-2"><CheckCircle2 className="w-4 h-4 text-emerald-500" /> Pagos realizados</p>
          {cobros.length === 0 ? <p className="text-xs text-slate-400">Todavía no hay pagos registrados.</p> : cobros.map((c) => (
            <div key={c.id ?? `${c.numero}-${c.fecha}-${c.importe}`} className="flex items-center justify-between gap-2 py-2 border-b last:border-0 border-slate-100 text-sm">
              <span><span className="font-semibold">{fechaCorta(c.fecha)}</span> <span className="text-xs text-slate-500">· {c.numero} · {METODOS[c.metodo] || c.metodo}</span></span>
              <span className="font-bold text-emerald-700 whitespace-nowrap">{eur(c.importe)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
